import React, { useEffect, useState } from "react";
import { useConfigurationState } from "./hooks/useConfigurationState";
import { Button } from "src/business-types/grocery/components/Button";
import { useUser } from "../context/UserContext";

function PosConfig() {
    const { user, userConfigration } = useUser();

    const {
        deliveryFeeEnabled,
        setDeliveryFeeEnabled,
        cardEnabled,
        setCardEnabled,
        savePosConfig,
        setOrderEditingEnabled,
        orderEditingEnabled,
    } = useConfigurationState();

    // Store initial values from API
    const [initialState, setInitialState] = useState({
        deliveryFeeEnabled: Boolean(userConfigration.deliveryFeeEnabled),
        cardEnabled: Boolean(userConfigration.cardPayment),
        orderEditingEnabled: Boolean(userConfigration.orderEditingEnabled),
    });

    // Update initial state whenever API data changes
    useEffect(() => {
        setInitialState({
            deliveryFeeEnabled: Boolean(userConfigration.deliveryFeeEnabled),
            cardEnabled: Boolean(userConfigration.cardPayment),
            orderEditingEnabled: Boolean(userConfigration.orderEditingEnabled),
        });
    }, [userConfigration]);

    console.log(Boolean(userConfigration.deliveryFeeEnabled), deliveryFeeEnabled);

    // Enable Save button only when values change
    const isSaveButtonEnabled =
        Boolean(userConfigration.deliveryFeeEnabled) === deliveryFeeEnabled
    const handleSave = async () => {
        try {
            await savePosConfig({
                deliveryFeeEnabled,
                // cardEnabled,
            });

            // Reset initial state after successful save
            setInitialState({
                deliveryFeeEnabled,
                cardEnabled,
                orderEditingEnabled,
            });
        } catch (error) {
            console.error("Failed to save configuration:", error);
        }
    };

    return (
        <div className="w-full p-4 overflow-y-auto">
            <div className="space-y-6 rounded-xl border bg-white p-6 shadow">
                <h2 className="text-xl font-bold">POS Configuration</h2>

                {/* Delivery Fee */}
                {user?.businessType !== "Grocery" && (
                    <>
                        <div>
                            <h3 className="mb-4 text-lg font-semibold">
                                Delivery Fee
                            </h3>

                            <label className="flex cursor-pointer items-start gap-2 pl-1">
                                <input
                                    type="checkbox"
                                    checked={deliveryFeeEnabled}
                                    onChange={() =>
                                        setDeliveryFeeEnabled(!deliveryFeeEnabled)
                                    }
                                    className="mt-1 h-4 w-4"
                                />

                                <div>
                                    <span className="font-medium">
                                        Enable Delivery Fee
                                    </span>

                                    {!deliveryFeeEnabled && (
                                        <p className="text-xs text-gray-500">
                                            Enable delivery fee to allow adding delivery
                                            charges to orders.
                                        </p>
                                    )}
                                </div>
                            </label>
                        </div>

                        <div className="border-t"></div>
                    </>
                )}
                {user?.businessType === "Grocery" && (
                    <div className="ml-4 flex flex-col gap-2 shadow-inner rounded-md border border-gray-200 bg-gray-50 p-4">
                        <h3 className="mb-2 text-lg font-bold">
                            Order Editing
                        </h3>
                        <div className="flex items-center gap-2 p-2">
                            <input type="checkbox" checked={orderEditingEnabled} onChange={() => setOrderEditingEnabled(!orderEditingEnabled)} />
                            <p>Enable Order Editing</p>
                        </div>
                    </div>
                )

                }

                {/* Card Payment */}
                {/* <div>
                    <h3 className="mb-4 text-lg font-semibold">
                        Card Payment
                    </h3>

                    <label className="flex cursor-pointer items-start gap-2 pl-1">
                        <input
                            type="checkbox"
                            checked={cardEnabled}
                            onChange={() => setCardEnabled(!cardEnabled)}
                            className="mt-1 h-4 w-4"
                        />

                        <div>
                            <span className="font-medium">
                                Enable Card Payment
                            </span>

                            {!cardEnabled && (
                                <p className="text-xs text-gray-500">
                                    Enable card payment to allow customers to pay
                                    with credit/debit cards using Razorpay.
                                </p>
                            )}
                        </div>
                    </label>
                </div> */}

                {/* Save Button */}
                <div className="flex justify-center">
                    <Button
                        label="Save POS Configuration"
                        onClick={handleSave}
                        variant="primary"
                    />
                </div>
            </div>
        </div>
    );
}

export default PosConfig;